import { render, staticRenderFns } from "./ReviewCard.vue?vue&type=template&id=255decf0&"
import script from "./ReviewCard.vue?vue&type=script&lang=ts&"
export * from "./ReviewCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports